import { createSlice } from "@reduxjs/toolkit";

const userSlice = createSlice({
  name: "user",
  initialState: {
    username: localStorage.getItem("username") || "",
    userId: localStorage.getItem("userid") || "",
    userProfilePic: localStorage.getItem("userProfilePic") || "/avatar.svg",
    userProfilePicDownloadUrl:
      localStorage.getItem("userProfilePicDownloadUrl") || "/avatar.svg",
    clientId: localStorage.getItem("clientId") || "",
    userStatus: localStorage.getItem("userStatus") || "",
    cardCurrencyName: JSON.parse(localStorage.getItem("cardCurrencyName")) || {
      value: 2,
      label: "AUD",
      symbol: "$",
    },
    updateFieldStatus: false,
    roleName: localStorage.getItem("roleName") || "super_admin",
    fileIdsRedux: [],
    fileDetails: localStorage.getItem("fileDetails") || "",
    isInvitee: JSON.parse(localStorage.getItem("isInvitee")) || false,
    isInviteeDirector:
      JSON.parse(localStorage.getItem("isInviteeDirector")) || false,
    isInviteeTrustee:
      JSON.parse(localStorage.getItem("isInviteeTrustee")) || false,
  },
  reducers: {
    setUsername: (state, action) => {
      localStorage.setItem("username", action.payload);
      state.username = action.payload;
    },
    setUserIdStore: (state, action) => {
      localStorage.setItem("userid", action.payload);
      state.userId = action.payload;
    },
    setUserProfilePicDownloadUrl: (state, action) => {
      localStorage.setItem("userProfilePicDownloadUrl", action.payload);
      state.userProfilePicDownloadUrl = action.payload;
    },
    setUserProfilePic: (state, action) => {
      localStorage.setItem("userProfilePic", action.payload);
      state.userProfilePic = action.payload;
    },
    setCardCurrencyName: (state, action) => {
      localStorage.setItem("cardCurrencyName", JSON.stringify(action.payload)); // ✅ stringify before saving
      state.cardCurrencyName = action.payload;
    },
    setClientId: (state, action) => {
      localStorage.setItem("clientId", action.payload);
      state.clientId = action.payload;
    },
    clearClientId: (state) => {
      localStorage.removeItem("clientId");
      state.clientId = null;
    },

    setUserStatus: (state, action) => {
      localStorage.setItem("userStatus", action.payload);
      state.userStatus = action.payload;
    },
    clearUserStatus: (state) => {
      localStorage.removeItem("userStatus");
      state.userStatus = null;
    },
    clearCardCurrencyName: (state) => {
      localStorage.removeItem("cardCurrencyName");
      state.cardCurrencyName = null;
    },
    clearUsername: (state) => {
      localStorage.removeItem("username");
      state.username = null;
    },
    clearUserProfilePicDownloadUrl: (state) => {
      localStorage.removeItem("userProfilePicDownloadUrl");
      state.userProfilePicDownloadUrl = null;
    },
    clearUserId: (state) => {
      localStorage.removeItem("userid");
      state.userId = null;
    },
    clearUserProfilePic: (state) => {
      localStorage.removeItem("userProfilePic");
      state.userProfilePic = null;
    },
    UpdateFieldStatusTrue: (state, action) => {
      state.updateFieldStatus = true;
    },
    UpdateFieldStatusFalse: (state) => {
      state.updateFieldStatus = false;
    },
    setRoleName: (state, action) => {
      localStorage.setItem("roleName", action.payload);
      state.roleName = action.payload;
    },
    clearRoleName: (state) => {
      localStorage.removeItem("roleName");
      state.roleName = null;
    },
    setFileIdsRedux: (state, action) => {
      state.fileIdsRedux = action.payload;
    },
    clearFileIdsRedux: (state) => {
      state.fileIdsRedux = [];
    },
    setFileDetails: (state, action) => {
      localStorage.setItem("fileDetails", action.payload);
      state.fileDetails = action.payload;
    },
    clearFileDetails: (state) => {
      localStorage.removeItem("fileDetails");
      state.fileDetails = "";
    },
    setIsInvitee: (state, action) => {
      localStorage.setItem("isInvitee", JSON.stringify(action.payload));
      state.isInvitee = action.payload;
    },
    clearIsInvitee: (state) => {
      localStorage.removeItem("isInvitee");
      state.isInvitee = "";
    },
    setIsInviteeTrustee: (state, action) => {
      localStorage.setItem("isInviteeTrustee", JSON.stringify(action.payload));
      state.isInviteeTrustee = action.payload;
    },
    setIsInviteeDirector: (state, action) => {
      localStorage.setItem("isInviteeDirector", JSON.stringify(action.payload));
      state.isInviteeDirector = action.payload;
    },
    clearIsInviteeDirector: (state) => {
      localStorage.removeItem("isInviteeDirector");
      state.isInviteeDirector = "";
    },
    clearIsInviteeTrustee: (state) => {
      localStorage.removeItem("isInviteeTrustee");
      state.isInviteeTrustee = "";
    },
  },
});

export const {
  setUsername,
  clearUsername,
  setUserIdStore,
  clearUserId,
  setUserProfilePic,
  clearUserProfilePic,
  clearUserProfilePicDownloadUrl,
  setUserProfilePicDownloadUrl,
  setCardCurrencyName,
  clearCardCurrencyName,
  setClientId,
  clearClientId,
  UpdateFieldStatusFalse,
  UpdateFieldStatusTrue,
  setRoleName,
  clearRoleName,
  setFileIdsRedux,
  clearFileIdsRedux,
  setFileDetails,
  clearFileDetails,
  setIsInvitee,
  clearIsInvitee,
  setUserStatus,
  clearUserStatus,
  setIsInviteeDirector,
  clearIsInviteeDirector,
  setIsInviteeTrustee,
  clearIsInviteeTrustee,
} = userSlice.actions;
export default userSlice.reducer;
